export const SERIES_REPETITION_DAILY = 'daily'
export const SERIES_REPETITION_WEEKLY = 'weekly'
export const SERIES_REPETITION_MONTHLY = 'monthly'
export const SERIES_REPETITION_WEEKDAYS = 'monday_to_friday'
export const SERIES_REPETITION_12X36 = '12x36'

export const SERIES_REPETITION_MONTHLY_ON_WEEKDAY = 'on_weekday'
export const SERIES_REPETITION_MONTHLY_ON_DAY_OF_MONTH = 'on_day_of_month'

export const SERIES_VACATION = 'vacation'
export const SERIES_DAY_OFF = 'day_off'
export const SERIES_WORKING_DAY = 'working_day'

export const SERIES_TYPES_LABELS = {
  [SERIES_VACATION]: 'Férias',
  [SERIES_DAY_OFF]: 'Folga',
  [SERIES_WORKING_DAY]: 'Jornada',
}

export const getSeriesTypeLabel = (type) => {
  if (!type) return 'Plantão'
  return SERIES_TYPES_LABELS[type] || 'Plantão'
}
